import { useState } from "react";
import { FileDown, FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const REPORTS = [
  { kind: "users", label: "Users", desc: "All accounts with plan & status" },
  { kind: "subscriptions", label: "Subscriptions", desc: "Plans, statuses & trials" },
  { kind: "revenue", label: "Revenue", desc: "Payment transactions" },
  { kind: "businesses", label: "Businesses", desc: "Formation / credit / funding status" },
  { kind: "audit", label: "Audit Log", desc: "Administrator actions" },
];
const FORMATS = [
  { fmt: "csv", label: "CSV", icon: FileDown },
  { fmt: "xlsx", label: "Excel", icon: FileSpreadsheet },
  { fmt: "pdf", label: "PDF", icon: FileText },
];

export default function AdminReports() {
  const [busy, setBusy] = useState("");

  const download = async (kind, fmt) => {
    const key = `${kind}-${fmt}`;
    setBusy(key);
    try {
      const res = await api.get(`/admin/reports/${kind}?format=${fmt}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${kind}_report.${fmt}`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${kind} report (${fmt.toUpperCase()}) downloaded`);
    } catch (e) {
      const status = e.response?.status;
      toast.error(status === 403 ? "You lack the reports.export permission" : `Export failed${status ? ` (HTTP ${status})` : ""}`);
    } finally { setBusy(""); }
  };

  return (
    <div data-testid="admin-reports">
      <h3 className="text-white font-medium mb-4">Export platform reports</h3>
      <div className="grid md:grid-cols-2 gap-4">
        {REPORTS.map((r) => (
          <div key={r.kind} className="rounded-2xl border border-white/8 bg-[#121214] p-5" data-testid={`report-${r.kind}`}>
            <div className="text-white font-medium">{r.label}</div>
            <p className="text-xs text-[#71717A] mb-4">{r.desc}</p>
            <div className="flex gap-2">
              {FORMATS.map((f) => {
                const Icon = f.icon; const key = `${r.kind}-${f.fmt}`;
                return (
                  <button key={f.fmt} onClick={() => download(r.kind, f.fmt)} disabled={busy === key}
                    data-testid={`report-${r.kind}-${f.fmt}`}
                    className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-white/10 text-[#D4D4D8] hover:border-[#D4AF37]/40 hover:text-white transition-colors disabled:opacity-50">
                    {busy === key ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Icon className="w-3.5 h-3.5" />} {f.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
